document.addEventListener('DOMContentLoaded', () => {
    const blocks = document.querySelectorAll('.content-tabs');
    const isMobile = window.matchMedia('(max-width: 980px)').matches;
    
    blocks.forEach(block => {
        // Preload images on mobile
        if (isMobile) {
            const images = block.querySelectorAll('.content-tab img');
            const newImages = block.querySelectorAll('.slide-image img');
            [...images, ...newImages].forEach(img => {
                if (img.src && !img.complete) {
                    const preloadImg = new Image();
                    preloadImg.src = img.src;
                }
            });
        }
        
        // New Mobile Slider Logic with Infinite Loop
        const slider = block.querySelector('.content-tabs__slider');
        const track = block.querySelector('.slider-track');
        if (!slider || !track) return;

        const slides = track.querySelectorAll('.slide');
        const totalOriginalSlides = slides.length;

        if (totalOriginalSlides < 2) return;

        // Clone first and last slides for infinite loop
        const firstClone = slides[0].cloneNode(true);
        const lastClone = slides[totalOriginalSlides - 1].cloneNode(true);

        firstClone.classList.add('clone');
        lastClone.classList.add('clone');

        // Append/Prepend clones
        // Structure: [Last Clone] [1] [2] ... [N] [First Clone]
        track.appendChild(firstClone);
        track.insertBefore(lastClone, slides[0]);

        // Get all slides including clones
        const allSlides = track.querySelectorAll('.slide');

        // Start at index 1 (the first real slide)
        let currentSlide = 1;
        let isAnimating = false;

        // Initialize position instantly (no transition)
        track.style.transition = 'none';
        slider.style.setProperty('--current-slide', currentSlide);
        // Force reflow
        track.offsetHeight;
        track.style.transition = '';

        const updateHeight = () => {
            const slide = allSlides[currentSlide];
            if (slide && slider) {
                slider.style.height = `${slide.offsetHeight}px`;
            }
        };

        // Initial height
        updateHeight();

        // Update height on resize (e.g. image load)
        const resizeObserver = new ResizeObserver(() => {
            updateHeight();
        });
        allSlides.forEach(slide => resizeObserver.observe(slide));

        const updateSlider = () => {
            slider.style.setProperty('--current-slide', currentSlide);
            updateHeight();
        };

        const handleTransitionEnd = () => {
            isAnimating = false;
            
            // Loop adjustment logic
            if (currentSlide === 0) {
                // We are at Last Clone -> Jump to Real Last
                track.style.transition = 'none';
                currentSlide = totalOriginalSlides;
                updateSlider();
                track.offsetHeight; // Force reflow
                track.style.transition = '';
            } else if (currentSlide === totalOriginalSlides + 1) {
                // We are at First Clone -> Jump to Real First
                track.style.transition = 'none';
                currentSlide = 1;
                updateSlider();
                track.offsetHeight; // Force reflow
                track.style.transition = '';
            }
        };

        track.addEventListener('transitionend', handleTransitionEnd);

        const nextSlide = () => {
            if (isAnimating) return;
            isAnimating = true;
            currentSlide++;
            updateSlider();
        };

        const prevSlide = () => {
            if (isAnimating) return;
            isAnimating = true;
            currentSlide--;
            updateSlider();
        };

        const prevBtn = block.querySelector('button.prev');
        const nextBtn = block.querySelector('button.next');

        if (prevBtn) prevBtn.addEventListener('click', prevSlide);
        if (nextBtn) nextBtn.addEventListener('click', nextSlide);

        // Swipe support
        let startX = null;
        const threshold = 50;

        slider.addEventListener('touchstart', (e) => {
            if (isAnimating) return;
            startX = e.touches[0].clientX;
        }, { passive: true });

        slider.addEventListener('touchend', (e) => {
            if (startX === null || isAnimating) return;
            const endX = e.changedTouches[0].clientX;
            const diffX = startX - endX;

            if (Math.abs(diffX) > threshold) {
                if (diffX > 0) {
                    nextSlide();
                } else {
                    prevSlide();
                }
            }
            startX = null;
        }, { passive: true });
    });
});
